import { Button, Modal, ModalDialog, Stack, Typography } from '@healthinal/ui';

export function LeavePageWarning({
  open,
  onDelete,
  onCancel,
  onSave,
  title,
}: {
  open: boolean;
  onDelete: () => void;
  onCancel: () => void;
  onSave: () => void;
  title: string;
}) {
  return (
    <Modal open={open} onClose={onCancel}>
      <ModalDialog>
        <Typography level={'h3'}>{title}</Typography>
        <Typography>
          Die Seite hat nicht gespeicherte Änderungen. Wenn Sie die Seite jetzt verlassen werden Ihre Daten nicht
          gespeichert.
        </Typography>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Button color={'danger'} onClick={onDelete}>
            Änderungen verwerfen
          </Button>
          <Stack direction={'row'} gap={1}>
            <Button color={'neutral'} onClick={onCancel}>
              Abbrechen
            </Button>
            <Button onClick={onSave}>Speichern</Button>
          </Stack>
        </Stack>
      </ModalDialog>
    </Modal>
  );
}
